import type { QueryClient } from '@tanstack/react-query';

/**
 * Refetcha `['rd-proposal', proposalId]` + `['rd-quote', proposalId]` em
 * paralelo. Extraído de `use-rd-lifecycle.hook.ts` (Step 5 — Cotação:
 * calculate/approve/accept/cancel/emit) e reutilizado por
 * `use-set-rd-params.hook.ts`/`use-set-rd-coverages.hook.ts`: qualquer
 * mutação que altere prêmio/coberturas/parâmetros precisa invalidar a
 * cotação exibida, não só a proposta — caso contrário o Step Cotação mostra
 * um prêmio desatualizado até o usuário clicar em "Recalcular".
 */
export async function refetchRdProposalAndQuote(
  queryClient: QueryClient,
  proposalId: string | undefined
): Promise<void> {
  await Promise.all([
    queryClient.refetchQueries({ queryKey: ['rd-proposal', proposalId] }),
    queryClient.refetchQueries({ queryKey: ['rd-quote', proposalId] }),
  ]);
}
